/**
 * @fileoverview conflictsTypes - Type definitions for entitlement conflicts
 *
 * Contains TypeScript interfaces and enums for entitlement conflicts functionality.
 * Defines data structures for API requests/responses, violating entitlements,
 * conflict objects, and search payloads.
 */

export enum EntitlementConflictsType {
  SLICE_NAME = 'aag/entitlementDetails/conflicts',
  API_SLICE_NAME = 'aag/entitlementDetailsConflictsApi',
}

export interface EntitlementConflictViolatingObject {
  fieldName: string;
  userValue: string;
  ruleValue: string;
  showObjectFieldLabel: boolean;
  objectValue: string;
}

export interface EntitlementConflictViolatingEntitlement {
  violationKey: number;
  functionKey: number;
  entitlementKey: number;
  entitlementValue: string | null;
  entitlementTypeName: string | null;
  entitlementDisplayName: string;
  objectValue: string | null;
  entitlementTrustScore: number;
  fieldName: string | null;
  fieldValue: string;
  userValue: string;
  ruleValue: string;
  firstUsed: string | null;
  lastUsed: string | null;
  totalUsed: number | null;
  object?: EntitlementConflictViolatingObject[] | null;
  showObjectFieldLabel: boolean;
  soxSeverity: string;
  sysSeverity: string;
  privilegedSeverity: string;
  description: string | null;
  glossary: string | null;
  customProperty1: string | null;
  accountKey: number;
  startDate: string | null;
  endDate: string | null;
}

export interface EntitlementConflictsSearchPayload {
  violatingSoxCriticality?: string[];
  violatingSysCriticality?: string[];
  violatingPrivileged?: string[];
  violatingEntitlements?: string[];
  assignedEntitlements?: string[];
  globalSearch?: string;
  searchAfter?: string[];
  max?: number;
}

export interface SearchEntitlementConflictsRequest {
  riskKey: string;
  functionId: string;
  assignedEntitlementId: string;
  payload: EntitlementConflictsSearchPayload;
}

export interface SearchEntitlementConflictsApiResponse {
  data: EntitlementConflictViolatingEntitlement[];
  status: number;
  message: string;
  afterKey: string | null;
  searchAfter: string[] | null;
  count: number | null;
}
